import { io } from 'socket.io-client';
import { appEnvVariables } from 'src/config';

export const socket = io(appEnvVariables.api || '', {
  transports: ['websocket'],
});

socket.on('connect', () => {
  console.log('Connected');
});

socket.on('error', (error) => {
  console.error(error);
});
